"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DateFormat;

module.exports = DateFormat = function () {
  var DateFormat = function () {
    function DateFormat(date) {
      _classCallCheck(this, DateFormat);

      this.date = date;
      if (this.date == null || !(this.date instanceof Date)) {
        this.date = new Date();
      }
      this.i18n = DateFormat.i18n;
    }

    _createClass(DateFormat, [{
      key: "pad",
      value: function pad(val) {
        var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

        return ("000000" + val).substr(-length, length);
      }
    }, {
      key: "yyyy",
      value: function yyyy() {
        return this.date.getFullYear().toString();
      }
    }, {
      key: "yy",
      value: function yy() {
        return this.yyyy().substr(2, 2);
      }
    }, {
      key: "M",
      value: function M() {
        return "" + (this.date.getMonth() + 1);
      }
    }, {
      key: "MM",
      value: function MM() {
        return this.pad(this.M());
      }
    }, {
      key: "MMMM",
      value: function MMMM() {
        return DateFormat.i18n.months[this.date.getMonth()];
      }
    }, {
      key: "MMM",
      value: function MMM() {
        return this.MMMM().substr(0, 3);
      }
    }, {
      key: "d",
      value: function d() {
        return "" + this.date.getDate();
      }
    }, {
      key: "dd",
      value: function dd() {
        return "" + this.pad(this.d());
      }
    }, {
      key: "EEEE",
      value: function EEEE() {
        return DateFormat.i18n.weekdays[this.date.getDay()];
      }
    }, {
      key: "EEE",
      value: function EEE() {
        return this.EEEE().substr(0, 3);
      }
    }, {
      key: "H",
      value: function H() {
        return "" + this.date.getHours();
      }
    }, {
      key: "HH",
      value: function HH() {
        return this.pad(this.H());
      }
    }, {
      key: "h",
      value: function h() {
        var h;
        if ((h = this.H()) < 13) {
          return h;
        } else {
          return "" + (h - 12);
        }
      }
    }, {
      key: "hh",
      value: function hh() {
        return this.pad(this.h());
      }
    }, {
      key: "m",
      value: function m() {
        return "" + this.date.getMinutes();
      }
    }, {
      key: "mm",
      value: function mm() {
        return "" + this.pad(this.m());
      }
    }, {
      key: "s",
      value: function s() {
        return "" + this.date.getSeconds();
      }
    }, {
      key: "ss",
      value: function ss() {
        return "" + this.pad(this.s());
      }
    }, {
      key: "a",
      value: function a() {
        if (this.H() < 13) {
          return "AM";
        } else {
          return "PM";
        }
      }
    }, {
      key: "z",
      value: function z() {
        var ref, ref1;
        return (typeof Intl !== "undefined" && Intl !== null ? (ref = Intl.DateTimeFormat()) != null ? (ref1 = ref.resolvedOptions()) != null ? ref1.timeZone : void 0 : void 0 : void 0) || "(Local Time)";
      }
    }, {
      key: "format",
      value: function format(_format) {
        var _this = this;

        return _format.replace(/([a-z])+/ig, function (val) {
          if (_this[val]) {
            return _this[val]();
          } else {
            return val;
          }
        });
      }
    }, {
      key: "parseString",
      value: function parseString(format, str) {
        return DateFormat.parseString(format, str);
      }
    }], [{
      key: "parseString",
      value: function parseString(format, str) {
        var counter, datePart, e, matchers, params, pattern, regex, vals;
        try {
          var _matchers;

          matchers = (_matchers = {
            'yyyy': {
              reg: '([0-9]{4})',
              param: 0
            },
            'yy': {
              reg: '([0-9]{2})',
              param: 0
            },
            'M': {
              reg: '([0-9]{1,2})',
              param: 1
            },
            'MM': {
              reg: '([0-9]{1,2})',
              param: 1
            },
            'MMM': {
              reg: '([a-z]{3})',
              param: 1
            },
            'MMMM': {
              reg: '([a-z]+)',
              param: 1
            },
            'dd': {
              reg: '([0-9]{1,2})',
              param: 2
            }
          }, _defineProperty(_matchers, "dd", {
            reg: '([0-9]{1,2})',
            param: 2
          }), _defineProperty(_matchers, 'd', {
            reg: '([0-9]{1,2})',
            param: 2
          }), _matchers);
          counter = 0;
          datePart = [];
          pattern = format.replace(/([a-z])+/ig, function (val) {
            if (matchers[val]) {
              datePart[counter] = val;
              counter++;
              return matchers[val].reg;
            }
            return val;
          });
          regex = new RegExp(pattern, "i");
          vals = str.match(regex);
          params = [];
          datePart.forEach(function (val, idx) {
            return params[matchers[val].param] = vals[idx + 1];
          });
          if (params[1] - 1 > -1) {
            if (params[1]) {
              params[1] = params[1] - 1;
            }
          } else {
            //lookup txt month
            params[1] = DateFormat.i18n.months.indexOf(DateFormat.i18n.months.filter(function (month) {
              return params[1].substr(0, 3) === month.substr(0, 3);
            })[0]);
          }
          if (params[0] < 90) {
            //treat all years under 90 as 2090
            params[0] = "20" + params[0];
          }
          return new Date(params[0], params[1], params[2]);
        } catch (error) {
          e = error;
          return false;
        }
      }
    }]);

    return DateFormat;
  }();

  ;

  DateFormat.i18n = {
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  };

  return DateFormat;
}.call(undefined);